import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';

import { Samples } from '@df/samples/samples';

import { Checkout } from '@df/checkout/checkout.interfaces';

@Injectable({
    providedIn: 'root'
})
export class SamplesCheckoutResolver implements Resolve<Checkout.IData> {
    constructor(private router: Router, private samples: Samples) {}

    resolve(): Promise<Checkout.IData> {
        return new Promise<Checkout.IData>((resolve, reject) => {
            this.samples
                .loadCheckout()
                .then(resolve)
                .catch(() => {
                    if (this.samples.config.checkoutErrorUrl) {
                        this.router.navigate([this.samples.config.checkoutErrorUrl]);
                    }
                    reject();
                });
        });
    }
}
